import { createStore } from 'redux';
import { persistReducer } from 'redux-persist';
import reducers from "../reducers/index";
import storage from 'redux-persist/lib/storage';

const persistConfig = { key: 'root', storage };
const persistedReducer = persistReducer(persistConfig, reducers); // to persist the store on refresh
export const store = createStore(persistedReducer,
  window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()); // library for testing redux